<template>
    <b-form id="conversion_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <label>Оффер</label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-11">
                <b-form-group>
                    <v-select :options="selectOffers" :filter="filterOffers" required label="title" v-model="selectedOffer"
                              placeholder="Оффер">
                        <span slot="no-options">Совпадений не найдено.</span>
                        <template slot="option" slot-scope="option">
                            <span>({{option.id}}) {{ option.title }}</span>
                        </template>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && !selectedOffer">Выберите оффер.</span>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Дата загрузки"
                              label-for="title">
                    <datepicker input-class="form-control"
                                class="date"
                                :language="ru"
                                v-model="conversion.item.loading_date"
                                placeholder=""></datepicker>
                    <span class=" alert-danger"
                          v-if="submitted && !conversion.item.loading_date">Заполните дату.</span>

                </b-form-group>
                <b-form-group label="Название платформы"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="conversion.item.platform_name">
                    </b-form-input>
                </b-form-group>


                <b-form-group label="Байер">
                    <v-select label="name" :options="users"

                              required v-model="selectedUser" placeholder="Медиабайер" >
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                  <span class=" alert-danger"
                        v-if="submitted && !selectedUser">Выберите байера.</span>
                </b-form-group>

                <b-form-group label="Группа источника">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="sourceGroupName">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !sourceGroupName">Заполните группу источника.</span>
                </b-form-group>
                <b-form-group label="Количество конверсий"
                              label-for="conversions_amount">
                    <b-form-input id="conversions_amount"
                                  type="number"
                                  v-model="conversion.item.conversions_amount">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !conversion.item.conversions_amount">Заполните количество конверсий.</span>
                </b-form-group>
                <b-form-group label="Adkey рейт"
                              label-for="adkey_rate">
                    <b-form-input id="adkey_rate"
                                  step="0.01"
                                  type="number"
                                  v-model="conversion.item.adkey_rate">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !conversion.item.adkey_rate">Заполните рейт.</span>
                </b-form-group>
                <b-form-group label="Валюта">
                    <v-select :options="currency" :searchable="false" required v-model="conversion.item.currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !conversion.item.currency">Добавьте валюту.</span>
                </b-form-group>
                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить и выйти
                </b-button>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import ConversionsService from '../../../services/conversionsDataService';
    import OffersService from '../../../services/offersDataService';

    import AdvertiserFormMixin from "../mixins/Advertiser/advertiserFormMixin";
    import {th} from "../../../services/customLocaleDatepicker";
    import Datepicker from 'vuejs-datepicker'
    import {ru} from '../../../services/customLocaleDatepicker'

    export default {
        name: 'EditConversionModal',
        components: {
            ConversionsService: ConversionsService,
            OffersService: OffersService,
            Datepicker: Datepicker
        },
        mixins:[AdvertiserFormMixin],
        props: {
            conversion: {
                default: function () {
                    return {
                        id: null,
                        loading_date: null,
                        offer_id: null,
                        platform_name: null,
                        buyer_id: null,
                        conversions_amount: null,
                        adkey_rate: null,
                        currency: null,
                        source_group_id: null
                    }
                }
            },
        },
        data() {
            return {
                currency: [],
                options: [this.conversion.item.id],
                submitted: false,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                selectOffers: [],
                selectedOffer: null,
                users: [],
                selectedUser: null,
                ru: ru,
                sourceGroupName: null
            }
        },
        methods: {
            onSubmit(evt) {
                this.submitted = true;

                if (!this.conversion.item.loading_date || !this.selectedUser || !this.selectedOffer || !this.conversion.item.conversions_amount || !this.conversion.item.currency || !this.conversion.item.adkey_rate || !this.sourceGroupName) {
                    evt.preventDefault();

                    return;
                }

                let conversion = {}

                conversion.id = this.conversion.item.id
                conversion.offer_id = this.selectedOffer.id
                conversion.buyer_id = this.selectedUser.network_partner_id
                conversion.loading_date = this.conversion.item.loading_date
                conversion.platform_name = this.conversion.item.platform_name
                conversion.conversions_amount = this.conversion.item.conversions_amount
                conversion.adkey_rate = this.conversion.item.adkey_rate
                conversion.currency = this.conversion.item.currency
                conversion.sourceGroupName = this.sourceGroupName

                ConversionsService.updateConversion(conversion)
                    .then(response => {
                            if (response) {
                                toastr.success('Ok')
                            } else {
                                toastr.error('Ошибка.')
                            }
                        })
                    .catch(err => {
                        toastr.error('Ошибка.')

                    })
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                        this.selectOffers.forEach(function (item) {
                            if (item.id == this.conversion.item.offer_id) {
                                this.selectedOffer = item
                            }
                        }.bind(this))


                    }.bind(this))
            },
            getGroups() {
                ConversionsService.getSourceGroups()
                    .then(function (groups) {
                        groups.forEach(function (item) {
                            if (item.id == this.conversion.item.source_group_id) {
                                this.sourceGroupName = item.name
                            }
                        }.bind(this))
                    }.bind(this))
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 577) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },

            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {
                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            getUsersWithPartnerNetworkId() {
                OffersService.getUsers()
                    .then(users => {
                        this.users = users

                        this.users.forEach(function (item) {
                            if (item.network_partner_id == this.conversion.item.buyer_id) {
                                this.selectedUser = item
                            }
                        }.bind(this))
                    })
            },
        },


        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        beforeMount() {
            this.getCurrency();
            this.getOffersForSelect()
            this.getUsersWithPartnerNetworkId()
            this.getGroups()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditConversionModal.vue